@if (certificate) {
  <div class="row">
    <div class="col-md-6">
      <fieldset style="border: 0">
        <form #certificateForm="ngForm">
          <div class="card ">
            <div class="card-body">
              <div class="form-group row">
                <app-material-auto-complete
                  [formatter]="certificateFormatter"
                  [(ngModel)]="name"
                  [items]="availableCertificates"
                  name="certificateList"
                  id="certificateList"
                  [placeholder]="'Name'"
                  [disabled]="editMode"
                  [required]="true">
                </app-material-auto-complete>
              </div>
              <div class="form-group row">
                <app-material-date-range
                  id="issueDate"
                  [singleDateSelector]="true"
                  [(dateRange)]="issueDate"
                  [placeholder]="'Issue Date'"
                  [localeDateFormat]="'YYYY-MM-DD'">
                </app-material-date-range>
              </div>
              <div class="form-group row">
                <app-material-date-range
                  id="expirationDate"
                  [singleDateSelector]="true"
                  [(dateRange)]="expirationDate"
                  [placeholder]="'Expiration Date'"
                  [localeDateFormat]="'YYYY-MM-DD'">
                </app-material-date-range>
              </div>
              <div class="form-group row">
                <app-material-chunk-file-uploader
                  [accept]="'.pdf'"
                  id="certificateFile"
                  name="certificateFile"
                  [(ngModel)]="doc"
                  (ngModelChange)="uploadCertificateFile($event)"
                  [required]="true">
                </app-material-chunk-file-uploader>
              </div>
              <div class="form-group row">
                <div>
                  <app-material-pg-button
                    class="pull-right"
                    [disabled]="!certificateForm.form.valid"
                    (clicked)="saveCertificate()"
                    label="Save">
                  </app-material-pg-button>
                  <app-material-pg-button
                    class="pull-right me-1"
                    (clicked)="cancel()"
                    label="Cancel">
                  </app-material-pg-button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </fieldset>
      @if ( certificate.history && certificate.history.length > 0) {
        <div class="card mt-4"
          >
          <div class="card-header">
            <strong>Certificate History</strong>
          </div>
          <div class="card-body">
            <table class="table table-sm table-bordered table-striped">
              <thead>
                <tr>
                  <th>Issue Date</th>
                  <th>Expiration Date</th>
                  <th>File</th>
                </tr>
              </thead>
              <tbody>
                @for (h of certificate.history; track $index) {
                  <tr>
                    <td>{{ dateTime(h.issueDate) }}</td>
                    <td>{{ dateTime(h.expirationDate) }}</td>
                    <td>
                      @if (h.fileId) {
                        <button class="btn btn-link p-0"
                          (click)="downloadFile(h.fileId, certificate?.name)">
                          Download
                        </button>
                      }
                      @if (!h.fileId) {
                        <span>-</span>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    </div>
    @if (fileId) {
      <div class="col-md-6">
        <app-material-pdf-viewer [fileId]="fileId"></app-material-pdf-viewer>
      </div>
    }
  </div>
}
